import request from "superagent";
import { getAuthHeader } from "../../utils/superagent";

export const setMetropolitanStatisticalArea = async (facilityId, metropolitanStatisticalArea) => {
  return request
    .put(`${global.api}/facilities/${facilityId}/address`)
    .set(await getAuthHeader())
    .send({ address: { metropolitanStatisticalArea } });
};

export const setMetropolitanStatisticalAreaHCP = async (agentId, metropolitanStatisticalArea) => {
  return request
    .put(`${global.api}/agentprofile/${agentId}/address`)
    .set(await getAuthHeader())
    .send({ address: { metropolitanStatisticalArea } });
};
